import { Component, OnInit } from '@angular/core';
import { QuestionnaireService } from '../questionnaire.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'app-questionnaire-respond',
    templateUrl: './questionnaire-respond.component.html',
    styleUrls: ['./questionnaire-respond.component.scss']
})
export class QuestionnaireRespondComponent implements OnInit
{

    requestId = '';
    errors = [];
    questionnaire;
    ratings = [
        { id: 1, selected: false },
        { id: 2, selected: false },
        { id: 3, selected: false },
        { id: 4, selected: false },
        { id: 5, selected: false },
    ];

    constructor(
        private questionnaireService: QuestionnaireService,
        private route: ActivatedRoute,
        private router: Router,
    )
    {
    }

    ngOnInit(): void
    {
        this.requestId = this.route.snapshot.params.id;
        this.getQuestionnaire();
    }

    setRating(question, r)
    {
        question.rating = r.id;
    }

    hoverRating(question, r)
    {
        question.ratingTmp = r.id;
    }

    clearHoverRating(question)
    {
        question.ratingTmp = 0;
    }

    toggleComment(product)
    {
        if (!product.addComment) {
            product.addComment = true;
        } else {
            product.addComment = false;
            product.comment = '';
        }
    }

    toggleAnswer(question, v)
    {
        question.answer = v;
    }

    getQuestionnaire()
    {
        this.questionnaireService.getQuestionnaire(this.requestId).subscribe(data =>
        {
            if (!data.data.errors.length) {
                this.questionnaire = data.data.questionnaire[0];
            } else {
                this.errors = data.data.errors;
            }
        });
    }

    complete()
    {
        this.questionnaireService.completeQuestionnaire(this.questionnaire).subscribe(data =>
        {
            // this.router.navigate(['/questionnaire', 'complete']);
        });
    }
}
